/**
 * /manager-review/v2 — pilot gate + test banner around ManagerReviewV2View. Anyone the proxy does
 * not let in is sent back to v1 (the proxy 403s them anyway; this only avoids a broken page).
 */
import { Navigate, useNavigate } from 'react-router-dom';
import { Button } from '@finn-auto/design-system/atoms/button';
import { Spinner } from '@finn-auto/design-system/atoms/spinner';
import { useManagerReviewV2Access } from '../components/manager-review-v2/useManagerReviewV2Access';
import ManagerReviewV2View from './ManagerReviewV2View';

export default function ManagerReviewV2Page() {
  const { enabled, live, loading } = useManagerReviewV2Access();
  const navigate = useNavigate();
  if (loading) {
    return <div className="flex justify-center p-12"><Spinner /></div>;
  }
  // After cutover v2 lives at /manager-review itself; v1 and this test route are gone.
  if (!enabled || live) return <Navigate to="/manager-review" replace />;
  // A floating pill, not a bar: v1's screens are full-bleed and 100vh, so anything taking layout
  // space would shift or cut them.
  return (
    <>
      <ManagerReviewV2View />
      <div className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-3 rounded-full border border-yellow-300 bg-yellow-50 py-1.5 pl-4 pr-1.5 text-sm text-gray-800 shadow">
        <span>Test version</span>
        <Button type="button" variant="outline" size="sm" onClick={() => navigate('/manager-review')}>
          Back to current version
        </Button>
      </div>
    </>
  );
}
